import { sleep } from '../common/utils';
const tabOpenDelay = 1000; // in milliseconds
export const openTabsWithDelay = async (urls: string[]) => {
    for (const url of urls) {
        window.open(url, '_blank');
        await sleep(tabOpenDelay);
    }
};
